const colors = {
  black: '#000000',
  white: '#FFFFFF',
  primary: {
    main: '#C5AA7C',
    100: '#F7F2EB',
    150: '#f8f0e5',
    200: '#E8DDCA',
    250: '#E2D4BD',
    300: '#D0BB96',
    500: '#C2A779'
  },
  secondary: {
    main: '#9D8193',
    100: '#E7E0E4',
    150: '#FCF2F7',
    175: '#DAD0D7',
    200: '#C4B3BE',
    400: '#9E8394',
    500: '#86647A',
    600: '#694D5F',
    800: '#382F2D'
  },
  gray: {
    50: '#F8F7F6',
    100: '#F6F2F4',
    115: '#ECE7EB',
    125: '#E0E0E0',
    150: '#D0D0D0',
    200: '#C6C6C6',
    225: '#BFBFBF',
    230: '#919191',
    250: '#999999',
    260: '#979797',
    275: '#777777',
    300: '#666666',
    325: '#726B70',
    350: '#707070',
    375: '#5B5B5B',
    400: '#555555',
    425: '#4F4F4F',
    450: '#444444',
    500: '#404040',
    550: '#363636',
    600: '#2D2E2D',
    800: '#222222'
  },
  red: {
    100: '#FAE4E5',
    200: '#771414',
    300: '#A75348',
    400: '#C73D3D',
    500: '#E31B23',
    600: '#9D2D2D',
    700: '#B40000',
    800: '#A82026',
    900: '#A80909'
  },
  blue: {
    main: '#464DEA',
    200: '#9192A3',
    300: '#365CFF',
    400: '#6D6E71',
    800: '#121C2B'
  },
  blackOpacity: {
    10: 'rgba(0, 0, 0, 0.1)',
    16: 'rgba(0, 0, 0, 0.16)'
  },
  whiteOpacity: {
    17: 'rgba(255, 255, 255, 0.17)',
    80: 'rgba(255, 255, 255, 0.80)'
  },
  secondaryOpacity: {
    30: 'rgba(134, 101, 122, 0.3)',
    90: 'rgba(134, 101, 122, 0.9)'
  },
  redOpacity: {
    5: 'rgba(180, 0, 0, 0.05)',
    50: 'rgba(227, 27, 35, 0.5)'
  },
  grayOpacity: {
    90: 'rgba(34, 34, 34, 0.9)'
  }
};

export default colors;
